@if (definition(); as def) {
  @if (selectMode()) {
    @if (multiple()) {
      <soft-ds-multi-select
        [items]="selectItems()"
        [value]="selectValues()"
        (valueChange)="onSelectValues($event)"
        [label]="selectLabel(def)"
        [placeholder]="placeholder() ?? def.placeholder"
        [listboxTitle]="overlayTitle() ?? def.title"
        [searchPlaceholder]="def.placeholder"
        [size]="size()"
        [required]="required()"
        [errors]="errors()"
        [invalid]="invalid()"
        [disabled]="readonly()"
        [presentation]="presentation()"
        searchable
        clearable
        filterMode="external"
        (searchChange)="onSelectSearch($event)"
        [emptyLabel]="selectEmptyLabel()"
        [optionsCount]="totalCount()"
        [hasMore]="hasMore()"
        [loadingMore]="loadingMore()"
        (scrolledToEnd)="onLoadMore()"
        (opened)="onSelectOpened()"
      />
    } @else {
      <soft-ds-select
        [items]="selectItems()"
        [value]="selectValue()"
        (valueChange)="onSelectValue($event)"
        [label]="selectLabel(def)"
        [leadingIcon]="def.icon"
        [placeholder]="placeholder() ?? def.placeholder"
        [listboxTitle]="overlayTitle() ?? def.title"
        [searchPlaceholder]="def.placeholder"
        [size]="size()"
        [required]="required()"
        [errors]="errors()"
        [invalid]="invalid()"
        [disabled]="readonly()"
        [presentation]="presentation()"
        searchable
        filterMode="external"
        (searchChange)="onSelectSearch($event)"
        [emptyLabel]="selectEmptyLabel()"
        [optionsCount]="totalCount()"
        [hasMore]="hasMore()"
        [loadingMore]="loadingMore()"
        (scrolledToEnd)="onLoadMore()"
        (opened)="onSelectOpened()"
      />
    }
  } @else {
    <soft-search-dropdown
      [searchFn]="searchFn"
      [abortInFlight]="abortInFlightSearch"
      [searchResults]="searchResults()"
      [totalCount]="totalCount()"
      [loading]="loading()"
      [hasMore]="hasMore()"
      [loadingMore]="loadingMore()"
      (loadMore)="onLoadMore()"
      (closed)="onSearchClosed()"
      [hasError]="error()"
      (retry)="retrySearch()"
      [selectedObject]="value()"
      (selectedObjectChange)="onSelected($event)"
      [multiple]="multiple()"
      [multiToggle]="multiToggle()"
      [multiToggleDefault]="multiToggleDefault()"
      [selectedObjects]="values()"
      (selectedObjectsChange)="values.set($event)"
      (confirmedMany)="onConfirmedMany($event)"
      [resultTemplate]="resultTemplate() ?? entityTemplate"
      [selectedTemplate]="selectedTemplate() ?? entitySelectedTemplate"
      [displayWith]="displayEntity"
      [keyOf]="keyOf"
      [trackWith]="trackOf"
      [avatarWith]="avatarWith()"
      [icon]="def.icon"
      [title]="overlayTitle() ?? def.title"
      [label]="label() || def.label"
      [showLabel]="showLabel()"
      [readonly]="readonly()"
      [size]="size()"
      [required]="required()"
      [errors]="errors()"
      [invalid]="invalid()"
      [presentation]="presentation()"
      [placeholder]="placeholder() ?? def.placeholder"
      [modalTitle]="'Erweiterte ' + def.title"
      [modalSubtitle]="def.label + ' durchsuchen und auswählen'"
      [tableView]="def.tableView ?? true"
      [inline]="inline()"
      [dropdownDisabled]="!openDropdownOnFocus()"
      [showSpecialQueryKey]="specialQueryKey()"
      [detailSidebar]="def.detailSidebar ?? false"
      [detailComponent]="detailComponent()"
      [detailInputs]="detailInputs()"
      [columns]="def.columns ?? []"
      [nameWith]="nameOf"
      [secondaryWith]="secondaryOf"
      [storageKey]="'masterdata-' + def.name"
      [bookmarksEnabled]="bookmarksEnabled()"
      [toFavoriteBody]="toFavoriteBody() ?? defaultToFavoriteBody"
      [toLastViewedBody]="toLastViewedBody() ?? defaultToLastViewedBody"
      [fromBookmarkBody]="fromBookmarkBody() ?? defaultFromBookmarkBody"
    />
  }
}

<ng-template #entityTemplate let-e let-term="searchTerm">
  <div class="masterdata-row">
    <div class="masterdata-row-text">
      <span
        class="ds-body-2-semibold masterdata-row-title"
        [innerHTML]="displayEntity(e) | highlightMatch: term"
      ></span>
      @if (secondaryOf(e); as secondary) {
        <span class="ds-caption text-light truncate">{{ secondary }}</span>
      }
    </div>
    @if (unitOf(e) || badgesOf(e).length > 0) {
      <div class="masterdata-row-trailing">
        @if (unitOf(e); as unit) {
          <span class="ds-caption text-light masterdata-row-unit">{{ unit }}</span>
        }
        @if (badgesOf(e); as badges) {
          @if (badges.length > 0) {
            <div class="masterdata-row-badges">
              @for (badge of badges; track badge.label) {
                <soft-ds-badge [variant]="badgeVariant(badge)" size="sm">
                  {{ badge.label }}
                </soft-ds-badge>
              }
            </div>
          }
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #entitySelectedTemplate let-e>
  <span class="text-sm truncate">{{ displayEntity(e) }}</span>
</ng-template>
